import { apiQuery } from '../';

export const templateApi = apiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      getTasks: builder.query({
        query: ({ filter = {}, page = 1 }) => {
          const { status, mode, outreach, schedule } = filter;
          const filter_by = {
            status: [],
            start_at: {},
          };
          if (status === 'failed') {
            filter_by.status = ['failed', 'aborted', 'skipped'];
          }

          if (status === 'completed') {
            filter_by.status = ['completed'];
          }

          if (status === 'pending') {
            filter_by.status = ['pending'];
            filter_by.start_at.from = 'past';
            filter_by.start_at.to = 'past';
          }

          if (status === 'today') {
            filter_by.status = ['pending'];
            filter_by.start_at.from = 'today';
            filter_by.start_at.to = 'today';
          }

          if (status === 'upcoming') {
            filter_by.status = ['pending'];
            filter_by.start_at.from = 'future';
            filter_by.start_at.to = 'future';
          }

          if (!status) {
            filter_by.status = ['pending'];
          }

          if (mode) {
            filter_by.mode = mode === 'all' ? null : [mode];
          }

          filter_by.flow_id = outreach?.length > 0 ? outreach : [];

          if (schedule !== null) {
            filter_by.within_schedule = schedule;
          }

          if (status === 'failed' || status === 'completed') {
            delete filter_by['within_schedule'];
          }

          const params = {
            items: 50,
            filter_by,
            page,
          };
          return {
            url: `/tasks`,
            params,
          };
        },
        providesTags: ['GetTasks'],
      }),

      getTaskById: builder.query({
        transformResponse: (response) => response?.data?.task,
        query: ({ taskId }) => {
          return {
            url: `/tasks/${taskId}`,
          };
        },
      }),

      getTaskSnapshot: builder.query({
        transformResponse: (response) => response?.data?.stats,
        query: () => {
          return {
            url: `/tasks/stats`,
          };
        },
        providesTags: ['GetTasksSnapshots'],
      }),

      completeTask: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ taskId, body, attachments }) => {
          const formData = new FormData();
          formData.append(`task[runnable_data][msg_body]`, body);
          if (attachments?.length) {
            for (const attachment of attachments) {
              if (attachment instanceof File) {
                formData.append(
                  `task[runnable_data][msg_attachments][]`,
                  attachment
                );
              } else {
                formData.append(
                  `task[runnable_data][msg_attachments][]`,
                  attachment?.id
                );
              }
            }
          } else {
            formData.append(`task[runnable_data][msg_attachments][]`, '');
          }
          return {
            url: `/tasks/${taskId}/complete`,
            method: 'put',
            data: formData,
          };
        },
        invalidatesTags: ['GetTasksSnapshots', 'GetChannelSettings'],
      }),

      skipTask: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ taskId }) => {
          return {
            url: `/tasks/${taskId}/skip`,
            method: 'put',
          };
        },
      }),

      snoozeTask: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ taskId, snoozeDuration }) => {
          return {
            url: `/tasks/${taskId}/snooze`,
            method: 'put',
            data: { task: { snooze_minutes: snoozeDuration } },
          };
        },
      }),

      skipBulkTask: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ tasksId }) => {
          return {
            url: `/tasks/bulk/skip`,
            method: 'put',
            data: { ids: tasksId },
          };
        },
        invalidatesTags: [
          'GetTasksSnapshots',
          'GetTasks',
          'GetChannelSettings',
        ],
      }),

      snoozeBulkTask: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ tasksId, snoozeDuration }) => {
          return {
            url: `/tasks/bulk/snooze`,
            method: 'put',
            data: { ids: tasksId, task: { snooze_minutes: snoozeDuration } },
          };
        },
        invalidatesTags: [
          'GetTasksSnapshots',
          'GetTasks',
          'GetChannelSettings',
        ],
      }),
    };
  },
  overrideExisting: true,
});

export const {
  useGetTasksQuery,
  useGetTaskByIdQuery,
  useGetTaskSnapshotQuery,
  useCompleteTaskMutation,
  useSkipTaskMutation,
  useSnoozeTaskMutation,
  useSkipBulkTaskMutation,
  useSnoozeBulkTaskMutation,
} = templateApi;
